module.exports = __webpack_public_path__ + "static/img/S116WP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S116WP_1.png
// module id = IMlj
// module chunks = 0